export default __webpack_public_path__ + "static/media/envelope-regular.14e86338.svg";